<template>
  
</template>

<script>
import axios from "axios";
import epsLoginFooter from "../LoginFooter.vue";
export default {
  components: {
    epsLoginFooter: epsLoginFooter
  },
  data() {
    return {
      
    };
  },
  methods: {
      
  },
  mounted() {
    var url =  new URL(location.href);
    const formdata = {
        uid:url.searchParams.get('uid'),
        hash:url.searchParams.get('hash'),
        tenant:url.searchParams.get('tenant'),
        backurl:url.searchParams.get('backurl')
    }
    console.log(formdata)
        axios
          .post("/management/redirectfromerp", formdata)
          .then(res => {
            window.console.log("res" , res.data);
            if (res.data.msg == "200") {
              localStorage.setItem("awspath",res.data.awspath)
              localStorage.setItem("EPS-token", res.data.token);
              localStorage.setItem("EPS-uid", res.data.uid);
              localStorage.setItem("EPS-tenant", res.data.tenant);
              this.$router.push("/eps-management-home");
              //window.location="/home"
            } else if(res.data.msg == "NAK") {
              this.message = "Please check ur credentials!!!";
              this.$router.push("/management-login");
            }
            else{
                window.location.href = res.data.backurl;
            }
          })
          .catch(error => {
            window.console.log(error);
            this.message = "Something went wrong";
          });
  }
};
</script>
<style scoped>
.pull-right {
  position: relative;
  text-align: center;
}
</style>